import React from "react";
import { CreateButton, Datagrid, Filter, List, ReferenceField, ReferenceInput, SearchInput, SelectInput, TextField } from "react-admin";
import { Permission } from "../../components";
import { PERMISSIONS } from "../../constants";
import ListPagination from "../../components/ListPagination";

const CityList = () => (
  <List
    title="Cidades"
    filters={<CityFilter />}
    actions={<CreateButton />}
    exporter={false}
    perPage={25}
    sort={{ field: "name", order: "ASC" }}
    pagination={<ListPagination />}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="name" label="Nome" />
      {Permission({
        permission: PERMISSIONS.ADMIN,
        children: (
          <ReferenceField source="chainId" reference="chains" label="Rede" link={false} sortable={false}>
            <TextField source="name" />
          </ReferenceField>
        )
      })}
    </Datagrid>
  </List>
);

const CityFilter = () => {
  return (
    <Filter>
      <SearchInput source="search" alwaysOn />
      {Permission({
        permission: PERMISSIONS.ADMIN,
        children: (
          <ReferenceInput
            reference="chains"
            source="chainId"
            style={{ minWidth: 220 }}
            sort={{ field: 'name', order: 'ASC' }}
            //@ts-ignore
            perPage={false}
            alwaysOn
          >
            <SelectInput
              label="Rede"
              emptyText="Todos"
              optionText="name"
            />
          </ReferenceInput>
        )
      })}
    </Filter>
  );
};

export default CityList;